import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReceiversShellComponent } from './containers/receivers-shell/receivers-shell.component';

const routes: Routes = [
  {
    path: '',
    component: ReceiversShellComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReceiversRoutingModule {}
